import { useParams } from "react-router";

import { FlowInstanceWizardWrapper } from "./flow-instance-wizard-wrapper";

export default function FlowInstancePage() {
  const { id: clientId, instanceId } = useParams();
  return <FlowInstanceWizardWrapper instanceId={instanceId!} clientId={clientId!} />;
}
